<script>
import NavBar from '@components/nav-bar'
import FilterBar from '@components/filter-bar'

export default {
  components: { NavBar, FilterBar },
}
</script>

<template>
  <div :class="$style.container">
    <header :class="$style.header">
      <NavBar/>
      <FilterBar v-if="this.$route.path === '/properties/' || this.$route.path === '/properties'"/>
    </header>
    <slot/>
    <footer :class="$style.footer">
      © Community Housing Network {{ new Date().getFullYear() }} ·
      <BaseLink href="mailto:ohlink@chninc.net">ohlink@chninc.net</BaseLink>·
      <BaseLink href="tel:2488247410">248.824.7410</BaseLink>
    </footer>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}

.header {
  background: white;
  border-bottom: 1px solid #ddd;
}

.footer {
  @extend %typography-xsmall;

  z-index: $layer-dropdown-z-index;
  padding: 5px 10px;
  font-style: italic;
  color: #bbb;
  text-align: center;
  background: #24292f;

  a {
    color: inherit;
  }
}
</style>
